import * as React from "react";
import { SVGProps } from "react";

const PlatinumTierLarge = (
  props: SVGProps<SVGSVGElement> & { bgcolor?: string }
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 73 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.8071 36.1574L61.8071 40.2747C61.8071 54.3685 50.4845 65.6911 36.3906 65.6911C22.2968 65.6911 10.9742 54.3685 10.9742 40.2747L10.9742 36.1574H61.8071Z"
      fill="#A776D3"
    />
    <path
      d="M54.5859 54.5858C44.5369 64.6348 28.2443 64.6348 18.1953 54.5858C8.14637 44.5368 8.14637 28.2442 18.1953 18.1952C28.2443 8.14627 44.5369 8.14627 54.5859 18.1952C64.6349 28.2442 64.6349 44.5368 54.5859 54.5858Z"
      fill="#D6B0FF"
    />
    <path
      d="M48.4941 48.4951C41.8095 55.1796 30.9717 55.1796 24.2872 48.4951C17.6026 41.8105 17.6026 30.9727 24.2872 24.2881C30.9717 17.6036 41.8095 17.6036 48.4941 24.2881C55.1787 30.9727 55.1787 41.8105 48.4941 48.4951Z"
      fill="#F19520"
    />
    <path
      d="M10.6604 36.3112C10.6604 50.5789 22.1226 62.0411 36.3903 62.0411C47.2914 62.0411 56.5895 55.308 60.3568 45.7696C52.1008 47.1322 41.5202 45.5291 31.1802 40.4793C23.4051 36.712 17.153 31.7424 12.7445 26.3719C11.3818 29.498 10.6604 32.7844 10.6604 36.3112Z"
      fill="#DAAEFF"
    />
    <path
      d="M48.4941 48.4951C41.8095 55.1796 30.9717 55.1796 24.2872 48.4951C17.6026 41.8105 17.6026 30.9727 24.2872 24.2881C30.9717 17.6036 41.8095 17.6036 48.4941 24.2881C55.1787 30.9727 55.1787 41.8105 48.4941 48.4951Z"
      fill="#A776D3"
    />
    <path
      d="M22.2839 26.6119C25.0092 24.6881 28.3757 23.566 31.9827 23.6461C41.4411 23.6461 49.0558 31.2609 49.0558 40.7192C49.0558 44.2461 47.9336 47.6126 46.0901 50.418C50.5788 47.3721 53.5445 42.162 53.4644 36.3107C53.4644 26.8523 45.8496 19.2376 36.3913 19.2376C30.6201 19.2376 25.41 22.2033 22.2839 26.6119Z"
      fill="#9645DF"
    />
    <path
      opacity="0.2"
      d="M36.4126 19.2269C33.0945 19.2268 30.4047 17.2982 30.4048 14.9192C30.4048 12.5402 33.0947 10.6117 36.4127 10.6118C39.7308 10.6118 42.4206 12.5404 42.4206 14.9194C42.4205 17.2984 39.7307 19.227 36.4126 19.2269Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.4126 62.0294C33.0945 62.0293 30.4047 60.1007 30.4048 57.7217C30.4048 55.3427 33.0947 53.4142 36.4127 53.4142C39.7308 53.4143 42.4206 55.3429 42.4206 57.7219C42.4205 60.1009 39.7307 62.0294 36.4126 62.0294Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.3809 14.7019C34.8157 14.7019 33.5469 13.7883 33.547 12.6614C33.547 11.5345 34.8158 10.621 36.3809 10.621C37.9461 10.6211 39.2148 11.5346 39.2148 12.6615C39.2148 13.7884 37.946 14.7019 36.3809 14.7019Z"
      fill="white"
    />
    <path
      d="M40.9314 29.8532H31.8273C31.0092 29.8532 30.2521 30.2857 29.8365 30.9904L27.7561 34.518C27.2664 35.3484 27.3435 36.3954 27.9496 37.1451L34.582 45.3493C35.5071 46.4935 37.2517 46.4935 38.1767 45.3493L44.8092 37.1451C45.4152 36.3954 45.4923 35.3484 45.0026 34.518L42.9222 30.9904C42.5066 30.2857 41.7495 29.8532 40.9314 29.8532Z"
      fill="url(#paint0_radial_6380_398)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_6380_398"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-8.47446 25.4234 -27.0869 -8.93956 42.1574 22.3418)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F1FA" />
        <stop offset="0.471154" stop-color="#F4F4FF" />
        <stop offset="1" stop-color="#D6B0FF" />
      </radialGradient>
    </defs>
  </svg>
);
export default PlatinumTierLarge;
